/**
 * DOCUMENT MODAL CONFIG REGISTRY
 *
 * Client-side singleton registry for document modal configuration.
 * Loaded from YAML at app startup via configLoader.server.ts.
 * Provides in-memory lookups for document configs and promotion targets.
 */

import type {
  DocumentConfigYaml,
  DocumentModalConfig,
  PromotionTargetYaml,
} from './types';

export class DocumentModalRegistry {
  private documentConfigs: Map<string, DocumentConfigYaml> = new Map();
  private promotionTargets: Map<string, PromotionTargetYaml[]> = new Map();
  private initialized = false;

  loadConfig(config: DocumentModalConfig): void {
    this.documentConfigs.clear();
    this.promotionTargets.clear();

    if (config.document_configs) {
      for (const [key, entry] of Object.entries(config.document_configs)) {
        this.documentConfigs.set(key, entry);
      }
    }

    if (config.promotion_targets) {
      for (const [key, targets] of Object.entries(config.promotion_targets)) {
        this.promotionTargets.set(key, targets);
      }
    }

    this.initialized = true;
  }

  isInitialized(): boolean {
    return this.initialized;
  }

  getDocumentConfig(docType: string): DocumentConfigYaml | null {
    return this.documentConfigs.get(docType) || null;
  }

  getAllDocumentConfigs(): Map<string, DocumentConfigYaml> {
    return this.documentConfigs;
  }

  getPromotionTargets(docType: string): PromotionTargetYaml[] {
    return this.promotionTargets.get(docType) || [];
  }
}

let registryInstance: DocumentModalRegistry | null = null;

export function getDocumentModalRegistry(): DocumentModalRegistry {
  if (!registryInstance) {
    registryInstance = new DocumentModalRegistry();
  }
  return registryInstance;
}
